// quest and activity dimentions
export const questWidth = 48
export const dividerWidth = 9
export const activityHeight = 41
export const activitiesPaddingBottom = 20

const getMaxActivities = (quests, initial) => quests.reduce((m, q) =>
  q.activities_count > m ? q.activities_count : m,
  initial
)

const getLevelMaxActvities = (requiredQuests, choiceQuests) =>
  getMaxActivities(
    requiredQuests,
    getMaxActivities(choiceQuests, 0)
  )

export const getActivitiesHeight = (
  requiredQuests,
  choiceQuests,
  isActivityCourse,
  includeOverview
) =>
  (getLevelMaxActvities(requiredQuests, choiceQuests) +
    (!isActivityCourse && includeOverview ? 1 : 0)
  ) * activityHeight +
  activitiesPaddingBottom
